'use client';

import Image from 'next/image';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

interface ThemeAwareLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function ThemeAwareLogo({ width = 96, height = 96, className = '' }: ThemeAwareLogoProps) {
  const { resolvedTheme } = useTheme();
  const [logoSrc, setLogoSrc] = useState('/images/logo-black.png');
  const [mounted, setMounted] = useState(false);

  // Only render logo after mounting to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setLogoSrc(resolvedTheme === 'dark' ? '/images/logo-white.png' : '/images/logo-black.png');
    }
  }, [resolvedTheme, mounted]);

  if (!mounted) {
    return null; // Avoid rendering during SSR
  }

  return (
    <Image
      src={logoSrc}
      alt="Fomogo"
      width={width}
      height={height}
      className={`rounded-full transition-transform hover:scale-105 ${className}`}
    />
  );
} 